import { jwtDecode, type JwtPayload } from 'jwt-decode';

export interface JwtToken extends JwtPayload {
  atype: 'anonymous' | 'identity';
  did: string;
  mvpdid: string;
  utype: string;
  ent?: Record<string, string>;
}

export function getDecodedJwt(accessToken?: string): JwtToken {
  if (!accessToken) {
    return {
      atype: 'anonymous',
      did: '',
      mvpdid: '',
      utype: '',
    };
  }

  const { atype, did, mvpdid, sub, utype, ent } = jwtDecode<JwtToken>(accessToken);

  return { atype, did, mvpdid, sub, utype, ent };
}
